<template lang="html">
  <transition name="zoom" appear>
    <button :aria-label="icon" class="prt-fab" v-show="visible">
      <prt-icon :icon="icon" />
    </button>
  </transition>
</template>

<script>
import PrtIcon from './PrtIcon.vue';

export default {
  components: {
    PrtIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-fab
    background-color: positive
    box-shadow: 0 2px 4px black-12
    color: white
    border: none
    outline: none
    width: 56px
    height: @width
    border-radius: (@width / 2)px
    box-sizing: border-box
    padding: 19px
    position: fixed
    bottom: 72px
    right: 16px
    z-index: 999
    cursor: pointer
    -webkit-tap-highlight-color: transparent
    transition: background-color 200ms ease

    &:active
      background-color: lighten(positive, 30%)
      transform: translateY(2px)

    &.zoom-enter-active,
    &.zoom-leave-active
      transition: transform 200ms ease

      .prt-icon
        transition: transform 100ms ease

    &.zoom-enter,
    &.zoom-leave-to
      transform: scale(0)

      .prt-icon
        transform: scale(0)
</style>
